import gravyAxios from "@/plugins/axios";

const productsStore = {
    state: () => ({
        products: [],
        product: null,
    }),
    actions: {
        getProducts: async ({commit}, clientId) => {
            let products = await gravyAxios.get(`/products/${clientId}`)
            commit('SET_PRODUCTS', products.data)
        },
        getProduct: async ({commit}, product) => {
            let productFetched = await gravyAxios.get(`/product/${product.id}`)
            commit('SET_PRODUCT', productFetched.data)
        },
        createProduct: async ({commit}, product) => {
            let newProduct = await gravyAxios.post('/product', product)
            commit('NEW_PRODUCT', newProduct.data)
        },
        updateProduct: async ({commit}, product) => {
            let updatedProduct = await gravyAxios.patch('/product', product)
            commit('UPDATE_PRODUCT', updatedProduct.data)
        },
        deleteProduct: async ({commit}, product) => {
            let deletedProduct = await gravyAxios.delete('/product/' + product.id)
            commit('DELETE_PRODUCT', product.id)
        },
        resetProducts: async ({commit}) => {
            commit('RESET_PRODUCTS')
        }
    },
    mutations: {
        NEW_PRODUCT: (state, product) => {
            state.products.push(product);
        },

        UPDATE_PRODUCT: (state, updatedProduct) => {
            const index = state.products.findIndex(product => product.id === updatedProduct.id);
            if (index !== -1) {
                state.products.splice(index, 1, updatedProduct);
            }
        },

        SET_PRODUCT: (state, product) => {
            state.product = product
        },
        SET_PRODUCTS: (state, products) => {
            if (!products) {
                return
            }
            state.products = products
        },
        CLEAR_ACTIVE_PRODUCT: state => {
            state.product = null
        },
        DELETE_PRODUCT: (state, productId) => {
            const index = state.products.findIndex(product => product.id === productId);
            state.products.splice(index, 1);
        },
        RESET_PRODUCTS: (state) => {
            state.products = []
        }

    },
    getters: {
        getProducts: state => {
            return state.products
        },
        getProduct: state => {
            return state.product
        },
    }
}

export default productsStore
